import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';

import { LoadingCoordinatorService } from '../../services/loading/loading-coordinator.service';
import { Mat3ButtonComponent } from '../base-components/mat3-button/mat3-button.component';

@Component({
  selector: 'app-error',
  imports: [RouterModule, Mat3ButtonComponent, TranslatePipe],
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppErrorComponent implements OnInit {
  private loadingCoordinator = inject(LoadingCoordinatorService);
  private route = inject(ActivatedRoute);
  private destroyRef = inject(DestroyRef);

  isAuthError = signal(false);

  ngOnInit(): void {
    this.loadingCoordinator.setGuardsComplete(true);
    this.loadingCoordinator.setPublicPageRendered();

    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.isAuthError.set(params['error'] === 'AUTH_ERROR');
    });
  }

  retryAuth(): void {
    window.location.href = window.location.origin;
  }
}
